jQuery(document).ready(function($) {
  if($('.sortable').length) {
    if($('form.table-reorder .table-hold').length) {
      var max_width = Math.max.apply(Math, 
        $('form.table-reorder .table-hold').map(function(){ 
          return $(this).outerWidth(); 
        }).get()
      );

      var max_height = Math.max.apply(Math, 
        $('form.table-reorder .table-hold').map(function(){ 
          return $(this).outerHeight(); 
        }).get()
      );

      $( "<style>body .table-highlight { width: "+max_width+"px; height: "+max_height+"px; }</style>" ).appendTo( "head" );

      $('form.table-reorder .table-hold').outerWidth(max_width).outerHeight(max_height);
    }
    $('.sortable').sortable({
      placeholder: "table-highlight",
      forcePlaceholderSize: 1,
      tolerance: "pointer",
    });
  }
})